import { takeLatest, call, select, put, delay } from "redux-saga/effects"
import {
	GET_FILE_LIST_REQUEST,
	GET_FILE_LIST_REQUEST_SUCCESS,
	GET_FILE_LIST_REQUEST_FAILED,
	GET_FILE_LIST_REQUEST_FAILED_CLEAR,
	SEARCH_ADD_CONCEPT_TARGET_TERMS,
} from "../types"
import axiosClient from "axios"
import { documentsService } from "../services/documents.services"
import { clearLocalStorage, reSortArray, searchTermParse } from "../utils"

function* getSearchFileListSaga(action) {
	try {
		const sourceApi = yield select((state) => state?.info?.sourcesList)
		const { searchObject, filter, categories, cancelToken, skipCount, selectedTag, currentSort } = action.payload
		const searchTerms = searchTermParse(searchObject)
		const response = yield call(
			documentsService.searchDocsView,
			searchTerms,
			"",
			filter,
			categories,
			false,
			20,
			cancelToken,
			sourceApi,
			skipCount,
			selectedTag,
			currentSort
		)
		let jobResponse = yield call(documentsService.getStatusJobId, response.data.job_id)

		while (
			(jobResponse?.data && jobResponse.data.job.job_status.success === false) ||
			jobResponse.data.job.job_status.is_finished === false
		) {
			yield delay(1000)
			jobResponse = yield call(documentsService.getStatusJobId, response.data.job_id)
		}

		if (jobResponse?.data && jobResponse.data.job.job_status.success === true) {
			// yield put ({
			//     type: JOB_STATUS_SUCCESS,
			//     payload: {
			//         jobId: response.data.job_id,
			//         status: jobId.data.job.job_status.success,
			//         location: location
			//     }
			// });

			const responseIds = yield call(documentsService.searchJobId, response.data.job_id)

			const docIdArray = []
			for (var i = 0; i < responseIds.data.data.data.length; i++) {
				docIdArray.push(`${responseIds.data.data.data[i].id}`)
			}

			const response_docsData = yield call(documentsService.getDocumentsData, docIdArray)
			const sortedData = reSortArray(docIdArray, response_docsData.data.data)

			yield put({
				type: GET_FILE_LIST_REQUEST_SUCCESS,
				payload: {
					id_search: responseIds.data.id,
					count: responseIds.data.data.count,
					data: sortedData,
				},
			})
			// yield put ({
			//     type: SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
			//     payload: searchTerms
			// })
			// if (categories.length > 0) {
			//     yield call (getTargetTermsOfCategory, categories);
			// }
			// dispatch(callUpdateSearchConceptTargetTerms(searchObject));
			yield put({
				type: SEARCH_ADD_CONCEPT_TARGET_TERMS,
				payload: searchTerms,
			})
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
				let alert = {
					msg: "There was an error. Please, try again and check your connection",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield put({
					type: GET_FILE_LIST_REQUEST_FAILED,
					payload: alert.msg,
				})
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export default function* fileListSaga() {
	yield takeLatest(GET_FILE_LIST_REQUEST, getSearchFileListSaga)
}
